export const isItemVisible = (item, isPopup) => {
    return (!isPopup || item.showInPopup) && (!item.checkOption || item.checkOption(item.command));
};
